// ==========================================================================
// InteliSoft.ai — Mock data (frontend-only teaser)
// All content is stored here so backend integration is easy later.
// ==========================================================================

export const IMAGES = {
  heroBg:
    "https://images.unsplash.com/photo-1629904853716-f0bc54eea481?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  subscribeBg:
    "https://images.unsplash.com/photo-1606857521015-7f9fcf423740?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  dashboard:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const NAV_LINKS = [
  { label: "Startseite", href: "#home" },
  { label: "Highlights", href: "#features" },
  { label: "Über uns", href: "#overview" },
  { label: "Team", href: "#team" },
  { label: "Kontakt", href: "#contact" },
];

export const HERO = {
  brand: "InteliSoft.ai",
  title: "Wir entwickeln intelligente Software, die Ihr Business bewegt.",
  subtitle:
    "Maximale Geschwindigkeit trifft intelligente Entwicklung. Ihre individuelle SaaS-Lösung – entwickelt in der Schweiz – entsteht bei uns in nur wenigen Tagen.",
  cta: "Jetzt anfragen",
  videoUrl: "https://www.youtube.com/watch?v=owhuBrGIOsE",
};

// Lucide icon names are mapped in the component
export const FEATURES = [
  {
    icon: "Rocket",
    title: "Entwicklung in Tagen",
    text: "Wir liefern erste funktionierende Softwareversionen in nur wenigen Tagen – oft sogar in 48–72 Stunden. Schnell, präzise und ohne lange Wartezeiten.",
  },
  {
    icon: "KeyRound",
    title: "Direkter Zugang zur Software",
    text: "Sie erhalten sofort einen Login zur echten Oberfläche und können live sehen, wie Ihre Software entsteht.",
  },
  {
    icon: "MessagesSquare",
    title: "Echtzeit-Feedback",
    text: "Änderungen, Wünsche oder Ideen? Sie teilen sie direkt in der Anwendung mit, und wir setzen Anpassungen sofort um.",
  },
  {
    icon: "Puzzle",
    title: "Individuelle Software",
    text: "Jede Lösung wird exakt auf Ihre Prozesse und Anforderungen abgestimmt – flexibel, skalierbar und zukunftssicher.",
  },
  {
    icon: "MonitorSmartphone",
    title: "Mobil & Desktop",
    text: "Ihre Software funktioniert auf PC, Tablet und Smartphone – ohne Installation, direkt im Browser.",
  },
  {
    icon: "LayoutGrid",
    title: "Zentraler Login",
    text: "Alle Tools, Module und Einstellungen sind in einer einzigen Plattform gebündelt. Einloggen, arbeiten, fertig.",
  },
];

export const ABOUT = {
  subheading: "Warum unsere Software & unser Ansatz?",
  heading: "Warum unsere SaaS-Lösungen die richtige Wahl sind",
  text: "Viele Unternehmen möchten Prozesse digitalisieren, stossen jedoch schnell auf dieselben Probleme: lange Projektlaufzeiten, hohe Entwicklungskosten und technische Überforderung. Klassische Softwareprojekte dauern Monate, manchmal sogar Jahre, und verschlingen unnötig Ressourcen. Wir haben unseren gesamten Entwicklungsprozess so optimiert, dass wir diese Hürden beseitigen – und Ihnen eine Lösung bieten, die sofort Ergebnisse liefert.",
  cta: "Jetzt anfragen",
  benefitsTitle: "Unsere Kunden profitieren von:",
  benefits: [
    "Kurzen Projektlaufzeiten: Von der Idee bis zur ersten Version oft in wenigen Wochen.",
    "Hoher Flexibilität: Anpassungen und Erweiterungen sind auch nach dem Go-Live effizient möglich.",
    "Skalierbarkeit: Egal ob 5 oder 5.000 Benutzer – unsere Lösungen wachsen mit.",
  ],
  services: [
    { icon: "CalendarClock", title: "Projekte schneller planen & starten" },
    { icon: "Bot", title: "Mit Low-Code & KI entwickelt" },
    { icon: "Globe", title: "Direkt einsatzfähige Web-Anwendungen" },
    { icon: "UploadCloud", title: "Sichere Datei-Uploads & Cloud-Speicher" },
  ],
};

export const OVERVIEW = {
  heading: "Unsere Leistungen – Was wir anbieten",
  text: "Wir entwickeln für Ihr Unternehmen massgeschneiderte SaaS-Lösungen, die komplett im Browser genutzt werden können: Portale für Kunden, Partner oder Mitarbeiter, interne Management-Systeme (CRM, Ticketsysteme, Auftrags- oder Dokumentenverwaltung), spezialisierte Fachsoftware sowie Dashboards & Reporting-Lösungen.",
  slides: [
    "https://images.pexels.com/photos/7109314/pexels-photo-7109314.jpeg?auto=compress&cs=tinysrgb&w=1400",
    "https://images.pexels.com/photos/4007745/pexels-photo-4007745.jpeg?auto=compress&cs=tinysrgb&w=1400",
    "https://images.pexels.com/photos/97080/pexels-photo-97080.jpeg?auto=compress&cs=tinysrgb&w=1400",
  ],
};

export const TEAM = {
  heading: "Unser Team – Dynamisch. Digital. Lösungsorientiert.",
  text: "Wir sind ein dynamisches Software-Team, das Innovation nicht nur entwickelt, sondern lebt. Mit Leidenschaft für Technologie, klaren Prozessen und hohem Qualitätsanspruch gestalten wir digitale Lösungen mit echtem Mehrwert. Unsere Stärke liegt in der Kombination aus Expertise, Schnelligkeit und Flexibilität.",
  members: [
    {
      name: "Mark Sturm",
      role: "CEO – Unternehmensleitung",
      img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    },
    {
      name: "Urs Mägli",
      role: "CTO – Technische Leitung",
      img: "https://images.unsplash.com/photo-1648474484044-bb82df2f5a1f?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    },
    {
      name: "Denis Sieger",
      role: "CSO – Vertrieb",
      img: "https://images.pexels.com/photos/34299170/pexels-photo-34299170.jpeg?auto=compress&cs=tinysrgb&w=600",
    },
  ],
};

export const BLOG = {
  heading: "KI-Integration und Automatisierung",
  text: "Wir integrieren Künstliche Intelligenz in Ihre Anwendungen – nicht als Spielerei, sondern mit klarem Nutzen.",
  posts: [
    {
      title: "Automatische Texterkennung und Textgenerierung",
      img: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      type: "Image",
      date: "12. Nov 2024",
      author: "InteliSoft",
      comments: 23,
      excerpt:
        "Von der Dokumentenanalyse bis zur automatischen Erstellung von Berichten – KI übernimmt wiederkehrende Textaufgaben und spart Ihrem Team wertvolle Zeit.",
    },
    {
      title: "Intelligente Suchfunktionen und Filter",
      img: "https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      type: "Video",
      date: "09. Nov 2024",
      author: "InteliSoft",
      comments: 47,
      excerpt:
        "Semantische Suche und smarte Filter finden genau das, was Ihre Nutzer suchen – schneller und präziser als klassische Volltextsuche.",
    },
    {
      title: "Datenanalyse und Mustererkennung",
      img: "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      type: "Images",
      date: "16. Nov 2024",
      author: "InteliSoft",
      comments: 58,
      excerpt:
        "KI erkennt Muster in Ihren Daten, prognostiziert Trends und liefert Handlungsempfehlungen in Echtzeit – direkt in Ihrem Dashboard.",
    },
  ],
};

export const PROJECTS = {
  heading: "Aktuelle Projekte",
  items: [
    {
      text: "Für einen Schweizer Gutachterbetrieb haben wir eine Bewertungs-Plattform entwickelt, die Gutachten in Minuten statt Stunden erstellt – inklusive PDF-Export und Kundenportal. Die erste Version war nach 4 Tagen live.",
      name: "Bewertungs-Plattform",
      role: "Fachsoftware · Immobilien",
      img: "https://images.pexels.com/photos/97080/pexels-photo-97080.jpeg?auto=compress&cs=tinysrgb&w=200",
    },
    {
      text: "Ein Handelsunternehmen aus Basel nutzt unser individuelles CRM mit Ticketsystem und automatisierten E-Mail-Workflows. Über 200 Mitarbeitende arbeiten täglich in der Plattform.",
      name: "CRM & Ticketsystem",
      role: "Interne Management-Software",
      img: "https://images.pexels.com/photos/7109314/pexels-photo-7109314.jpeg?auto=compress&cs=tinysrgb&w=200",
    },
    {
      text: "Für einen Dienstleister realisierten wir ein Kundenportal mit Live-Dashboards und Reporting. Die KI-gestützte Auswertung liefert Prognosen in Echtzeit und ersetzt manuelle Excel-Reports.",
      name: "Kundenportal & Reporting",
      role: "Dashboards & Analytics",
      img: "https://images.pexels.com/photos/4007745/pexels-photo-4007745.jpeg?auto=compress&cs=tinysrgb&w=200",
    },
  ],
};

export const CONTACT = {
  heading: "Kontaktieren Sie uns",
  text: "Erzählen Sie uns von Ihrem Projekt. Wir melden uns innerhalb von 24 Stunden und zeigen Ihnen, wie schnell Ihre individuelle Software Realität wird.",
  addressTitle: "Unser Standort",
  address: "Münchensteinerstrasse 128\n4052 Basel, Schweiz",
  phone: "+41 61 000 00 00",
  email: "info@intelisoft.ai",
};

export const FAQ = {
  heading: "Fragen & Antworten",
  text: "Die häufigsten Fragen rund um unsere SaaS-Entwicklung – kurz und ehrlich beantwortet.",
  items: [
    {
      q: "Wie schnell habe ich eine erste Version?",
      a: "In der Regel innerhalb von 48–72 Stunden erhalten Sie einen Login zu einer echten, funktionierenden ersten Version Ihrer Software, die wir gemeinsam iterativ weiterentwickeln.",
    },
    {
      q: "Brauche ich technisches Vorwissen?",
      a: "Nein. Sie beschreiben Ihre Prozesse und Ziele – den Rest übernehmen wir. Feedback geben Sie einfach direkt in der Anwendung.",
    },
    {
      q: "Wo werden meine Daten gespeichert?",
      a: "Als Schweizer Unternehmen legen wir grössten Wert auf Datenschutz. Auf Wunsch hosten wir Ihre Lösung ausschliesslich in Rechenzentren in der Schweiz.",
    },
    {
      q: "Ist die Software später erweiterbar?",
      a: "Ja. Unsere Lösungen sind modular und skalierbar aufgebaut – Erweiterungen und neue Module sind auch nach dem Go-Live jederzeit effizient möglich.",
    },
  ],
};

export const FOOTER = {
  about:
    "InteliSoft.ai entwickelt massgeschneiderte SaaS-Software in Rekordzeit – Made in Switzerland. Individuell, sicher und skalierbar.",
  quickLinks: [
    { label: "Startseite", href: "#home" },
    { label: "Highlights", href: "#features" },
    { label: "Über uns", href: "#overview" },
    { label: "Team", href: "#team" },
    { label: "Kontakt", href: "#contact" },
  ],
  community: ["Karriere", "Leadership", "Strategie", "Services", "Datenschutz"],
  website: "www.intelisoft.ai",
  email: "info@intelisoft.ai",
  phone: "+41 61 000 00 00",
};
